// JsFromRoutes CacheKey d146534ef046055c997477d3fc4a082f
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/consumer/contacts/:contact_id/invitations'),
}
